import { combineReducers } from "redux";

import app from "./app";
import attributeCollection from "./attributeCollection";
import bonusReport from "./bonusReport";
import casinoCollectionExecutions from "./casinoCollectionExecutions";
import casinos from "./casinos";
import countries from "./countries";
import currencies from "./currencies";
import environments from "./environments";
import gameCategories from "./gameCategories";
import gameConfiguration from "./gameConfiguration";
import gameGallery from "./gameGallery";
import games from "./games";
import integrators from "./integrators";
import integratorSetup from "./integratorSetup";
import invoicingReport from "./invoicingReport";
import jurisdictions from "./jurisdictions";
import languages from "./languages";
import operators from "./operators";
import software from "./software";
import transactionReport from "./transactionReport";
import users from "./users";

export default combineReducers({
  app,
  attributeCollection,
  bonusReport,
  casinos,
  currencies,
  countries,
  environments,
  gameCategories,
  gameConfiguration,
  games,
  integrators,
  integratorSetup,
  invoicingReport,
  jurisdictions,
  languages,
  operators,
  software,
  casinoCollectionExecutions,
  users,
  transactionReport,
  gameGallery,
});
